/**
 * OC MR Customers Say
 * - PC：视频弹窗（对齐 Story Cards：白框 16:9 / 80dvh / overlay 挂 body）
 * - 移动：媒体区内联 playsinline，不弹窗
 */
(function () {
  'use strict';

  if (customElements.get('oc-mr-customers-say')) return;

  class OcMrCustomersSay extends HTMLElement {
    connectedCallback() {
      if (this._bound) return;
      this._bound = true;

      this.overlay = this.querySelector('[data-cs-overlay]');
      this.dialogMedia = this.querySelector('[data-cs-dialog-media]');
      this._onKeydown = this._onKeydown.bind(this);

      this.querySelectorAll('[data-cs-play]').forEach((btn) => {
        btn.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.openVideo(btn);
        });
      });

      this.querySelectorAll('[data-cs-close]').forEach((el) => {
        el.addEventListener('click', () => this.closeVideo());
      });

      this._bindSwiperSlideChange();
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this._onKeydown);
      this._unlockScroll();
      this._restoreOverlay();
      this._stopAllInlinePlayers(null);
    }

    _isMobile() {
      return window.matchMedia('(max-width: 768px)').matches;
    }

    _bindSwiperSlideChange() {
      var host = this.querySelector('review-swiper');
      var self = this;
      if (!host) return;

      var tryBind = function () {
        if (self._swiperBound) return true;
        if (host.swiper && typeof host.swiper.on === 'function') {
          host.swiper.on('slideChange', function () {
            self._stopAllInlinePlayers(null);
          });
          self._swiperBound = true;
          return true;
        }
        return false;
      };

      if (!tryBind()) {
        window.setTimeout(tryBind, 300);
      }
    }

    _mountOverlay() {
      if (!this.overlay) return;
      if (!this._overlayHome) {
        this._overlayHome = this.overlay.parentElement;
      }
      if (this.overlay.parentElement !== document.body) {
        document.body.appendChild(this.overlay);
      }
    }

    _restoreOverlay() {
      if (!this.overlay || !this._overlayHome) return;
      if (this.overlay.parentElement === document.body) {
        this._overlayHome.appendChild(this.overlay);
      }
    }

    _stopAllInlinePlayers(exceptMedia) {
      this.querySelectorAll('.mr-review-slider__media.is-playing').forEach((media) => {
        if (exceptMedia && media === exceptMedia) return;
        var player = media.querySelector('.mr-review-slider__inline-player');
        if (player) {
          var vid = player.querySelector('video');
          if (vid) {
            try {
              vid.pause();
            } catch (e) {}
          }
          player.remove();
        }
        media.classList.remove('is-playing');
      });
    }

    _appendShopifyVideo(parent, src) {
      var video = document.createElement('video');
      video.src = src;
      video.setAttribute('controls', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.setAttribute('preload', 'auto');
      video.setAttribute('autoplay', '');
      video.playsInline = true;
      video.controls = true;
      video.autoplay = true;
      parent.appendChild(video);
      try {
        var p = video.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      } catch (e) {}
    }

    _appendYoutubeIframe(parent, ytId, muted) {
      var iframe = document.createElement('iframe');
      iframe.setAttribute(
        'allow',
        'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen'
      );
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('title', 'YouTube video');
      iframe.src =
        'https://www.youtube.com/embed/' +
        encodeURIComponent(ytId) +
        (muted
          ? '?autoplay=1&mute=1&playsinline=1&rel=0&modestbranding=1&enablejsapi=1'
          : '?autoplay=1&playsinline=1&rel=0&modestbranding=1&enablejsapi=1');
      parent.appendChild(iframe);
    }

    _openVideoInline(btn) {
      var media = btn.closest('.mr-review-slider__media');
      if (!media) return;
      if (media.classList.contains('is-playing')) return;

      var type = btn.getAttribute('data-video-type');
      this._stopAllInlinePlayers(media);
      media.classList.add('is-playing');

      var wrap = document.createElement('div');
      wrap.className = 'mr-review-slider__inline-player';

      if (type === 'shopify') {
        var src = btn.getAttribute('data-video-src');
        if (!src) {
          media.classList.remove('is-playing');
          return;
        }
        this._appendShopifyVideo(wrap, src);
        media.appendChild(wrap);
        return;
      }

      if (type === 'youtube') {
        var ytId = btn.getAttribute('data-youtube-id');
        if (!ytId) {
          media.classList.remove('is-playing');
          return;
        }
        this._appendYoutubeIframe(wrap, ytId, false);
        media.appendChild(wrap);
        return;
      }

      media.classList.remove('is-playing');
    }

    openVideo(btn) {
      if (!btn) return;

      if (this._isMobile()) {
        this._openVideoInline(btn);
        return;
      }

      if (!this.overlay || !this.dialogMedia) return;

      var type = btn.getAttribute('data-video-type');
      this.dialogMedia.innerHTML = '';

      this._mountOverlay();
      this.overlay.hidden = false;
      this._lockScroll();
      document.addEventListener('keydown', this._onKeydown);

      if (type === 'shopify') {
        var src = btn.getAttribute('data-video-src');
        if (!src) {
          this.closeVideo();
          return;
        }
        this._appendShopifyVideo(this.dialogMedia, src);
      } else if (type === 'youtube') {
        var ytId = btn.getAttribute('data-youtube-id');
        if (!ytId) {
          this.closeVideo();
          return;
        }
        this._appendYoutubeIframe(this.dialogMedia, ytId, true);
      } else {
        this.closeVideo();
        return;
      }

      var closeBtn = this.overlay.querySelector('.mr-review-slider__dialog-close');
      if (closeBtn) {
        requestAnimationFrame(function () {
          closeBtn.focus();
        });
      }
    }

    closeVideo() {
      if (!this.overlay) return;
      this.overlay.hidden = true;
      if (this.dialogMedia) {
        this.dialogMedia.innerHTML = '';
      }
      this._restoreOverlay();
      this._unlockScroll();
      document.removeEventListener('keydown', this._onKeydown);
    }

    _onKeydown(event) {
      if (event.key === 'Escape' || event.key === 'Esc') {
        event.preventDefault();
        this.closeVideo();
      }
    }

    _lockScroll() {
      document.documentElement.classList.add('oc-mr-cs-open');
    }

    _unlockScroll() {
      document.documentElement.classList.remove('oc-mr-cs-open');
    }
  }

  customElements.define('oc-mr-customers-say', OcMrCustomersSay);
})();
